// Mirror of /app/backend/roles.py — keep in sync.

export const VALID_ROLES = [
  "customer",
  "admin",
  "ops_admin",
  "ops_staff",
  "agent",
  "viewer",
  "superadmin",
];

export const ROLE_HIERARCHY = {
  superadmin: ["superadmin"],
  admin:      ["superadmin", "admin", "ops_admin", "ops_staff"],
  ops:        ["superadmin", "admin", "ops_admin", "ops_staff"],
  agent:      ["superadmin", "admin", "agent"],
  viewer:     ["superadmin", "admin", "ops_admin", "ops_staff", "viewer"],
  customer:   VALID_ROLES,
};

export function hasAccess(userRole, required) {
  return (ROLE_HIERARCHY[required] || []).includes(userRole);
}
